import routes from './routes';
import { SetRoutes } from 'components';

const ContractTypesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ContractTypesPages;
